<template>
  <div>
    <ul v-show="false">
      <li>storeIds: {{ params.storeIds }}</li>
      <li>itemIds: {{ params.itemIds }}</li>
      <li>typeId: {{ params.typeId }}</li>
      <li>documentTypeId: {{ params.documentTypeId }}</li>
      <li>counterpartySlug: {{ params.counterpartySlug }}</li>
      <li>counterpartyId: {{ params.counterpartyId }}</li>
      <li>totalCurrency: {{ params.totalCurrency }}</li>
      <li>forDate: {{ params.forDate }}</li>
      <li>docNum: {{ params.docNum }}</li>
      <li>docDate: {{ params.docDate }}</li>
    </ul>

    <b-row>
      <b-col>
        <v-radio-group v-model="params.documentTypeId">
          <v-radio
            v-for="documentType in documentTypesFiltered"
            :key="documentType.id"
            :label="documentType.name"
            :value="documentType.id"
          ></v-radio>
        </v-radio-group>
      </b-col>
      <b-col>
        <v-radio-group v-model="params.typeId">
          <v-radio
            v-for="paramType in types"
            :key="paramType.id"
            :label="paramType.name"
            :value="paramType.id"
          ></v-radio>
        </v-radio-group>
      </b-col>
      <b-col>
        <v-radio-group v-model="params.counterpartySlug">
          <v-radio
            v-for="counterparty in filteredCounterpartySlugs"
            :key="counterparty.slug"
            :label="counterparty.name"
            :value="counterparty.slug"
          ></v-radio>
        </v-radio-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <v-autocomplete
          v-if="params.counterpartySlug === 'supplier'"
          :items="suppliers"
          :label="$t('SUPPLIER')"
          item-text="name"
          item-value="id"
          clearable
          v-model="params.counterpartyId"
        ></v-autocomplete>

        <v-autocomplete
          v-if="params.counterpartySlug === 'client'"
          :items="clients"
          :label="$t('CLIENT')"
          item-text="name"
          item-value="id"
          clearable
          v-model="params.counterpartyId"
        ></v-autocomplete>

        <v-autocomplete
          v-if="params.counterpartySlug === 'forwarder'"
          :items="forwarders"
          :label="$t('FORWARDER')"
          item-text="name"
          item-value="id"
          clearable
          v-model="params.counterpartyId"
        ></v-autocomplete>
        <v-autocomplete
          v-if="params.counterpartySlug === 'contractor'"
          :items="contractors"
          :label="$t('CONTRACTOR')"
          item-text="name"
          item-value="id"
          clearable
          v-model="params.counterpartyId"
        ></v-autocomplete>
      </b-col>
      <b-col :lg="12" v-show="params.counterpartyId != null">
        <CheckboxList
          :heading="$t('STORES')"
          :items="stores"
          :selectedItems.sync="params.storeIds"
          :modelName="'stores'"
          :labelKey="'nameWithCity'"
          :sm="4"
        >
        </CheckboxList>
        <SkeletonLoaderCheckboxes
          :visible="firstLoader"
        ></SkeletonLoaderCheckboxes>
      </b-col>
      <b-col :lg="12" v-show="params.counterpartyId != null">
        <CheckboxList
          :heading="$t('ITEMS')"
          :items="filteredItems"
          :selectedItems.sync="params.itemIds"
          :modelName="'items'"
          :labelKey="'nameWithCode'"
          :sm="4"
        >
        </CheckboxList>
        <SkeletonLoaderCheckboxes
          :visible="firstLoader"
        ></SkeletonLoaderCheckboxes>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <v-text-field
          v-model="params.totalCurrency"
          :label="$t('TOTAL_CURRENCY')"
          hide-details
          type="number"
          step="0.01"
          min="0"
          @blur="filterPrice()"
        ></v-text-field>
      </b-col>
      <b-col>
        <v-text-field
          v-model="params.docNum"
          :label="$t('DOC_NUM')"
          hide-details
          type="number"
          step="1"
          min="0"
        ></v-text-field>
      </b-col>
      <b-col>
        <FormDatepickerBase
          :type="'text'"
          :i18n="{
            label: 'DOC_DATE',
            placeholder: $t('DOC_DATE')
          }"
          :date.sync="params.docDate"
        ></FormDatepickerBase>
      </b-col>
      <b-button
        :disabled="!isSaveValid"
        class="mr-3"
        variant="primary"
        @click="onSave"
        >{{ $t("SAVE") }}</b-button
      >
    </b-row>
  </div>
</template>
<script>
import { FETCH_SELECTS_BASIC } from "@/core/services/store/shared_base.module";

import { FETCH_STORES_BASIC } from "@/core/services/store/shared_store.module";
import { FETCH_ALL_ITEMS_MULTIPLE } from "@/modules/item/store/item.module";
import { CREATE_CREDIT_DEBIT_STOCK_ACTION } from "@/modules/stock/store/stock.module";

import CheckboxList from "@/view/content/forms/components/CheckboxList.vue";
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";
import _ from "lodash";
export default {
  name: "StockReceivingStepper",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10); // Format as "YYYY-MM-DD"
    return {
      params: {
        storeIds: [],
        itemIds: [],
        typeId: 2,
        documentTypeId: 3,
        counterpartySlug: "supplier",
        counterpartyId: null,
        totalCurrency: "0.00",
        forDate: formattedDate,
        docNum: "",
        docDate: formattedDate
      },
      items: [],
      suppliers: [],
      stores: [],
      forwarders: [],
      contractors: [],
      clients: [],
      types: [],
      counterpartySlugs: [
        { typeIds: [2], slug: "supplier", name: "Доставчик" },
        { typeIds: [2], slug: "forwarder", name: "Транспортна фирма" },
        { typeIds: [2], slug: "contractor", name: "Изпълнителна фирма" },
        { typeIds: [1], slug: "client", name: "Клиент" }
      ],
      documentTypes: []
    };
  },
  components: { CheckboxList, FormDatepickerBase },
  mounted() {
    let vm = this;

    vm.getStores();
    vm.getItems();
    vm.getSelects();
  },
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    isSaveValid() {
      if (
        this.params.storeIds.length > 0 &&
        this.params.itemIds.length > 0 &&
        this.params.totalCurrency > 0 &&
        this.params.docDate != null
      ) {
        return true;
      } else {
        return false;
      }
    },
    filteredCounterpartySlugs() {
      return this.counterpartySlugs.filter(slugData =>
        slugData.typeIds.includes(this.params.typeId)
      );
    },
    documentTypesFiltered() {
      // Use Array.prototype.filter to filter items with id equal to 3 or 4
      return this.documentTypes.filter(
        documentType => documentType.id === 3 || documentType.id === 4
      );
    },
    filteredItems() {
      if (this.params.storeIds.length === 0) {
        return []; // If params.storeIds is empty, return an empty array
      }

      return this.items.filter(item => {
        // Rule 1: Filter by counterpartySlug if it's not "forwarder" and not a contractor
        if (
          this.params.counterpartySlug !== "forwarder" &&
          this.params.counterpartySlug !== "contractor"
        ) {
          if (this.params.counterpartySlug === "supplier") {
            const counterparties = item["supplierIds"]; // e.g., suppliers or clients
            if (!counterparties.some(id => id === this.params.counterpartyId)) {
              return false; // Skip this item if the counterpartyId doesn't match
            }
          } else if (this.params.counterpartySlug === "client") {
            const counterparties = item["clientIds"]; // e.g., suppliers or clients
            if (!counterparties.some(id => id === this.params.counterpartyId)) {
              return false; // Skip this item if the counterpartyId doesn't match
            }
          }
        }

        // Rule 2: Check if item has at least one of the selected storeIds
        return this.params.storeIds.some(id => item.storeIds.includes(id));
      });
    }
  },
  watch: {
    "params.typeId": "updateCounterpartySlug", // Watch typeId changes
    "params.storeIds": "updateFilteredItems",
    "params.counterpartyId": "updateFilteredItems",
    "params.counterpartySlug": "resetCounterpartyId"
  },
  methods: {
    getStores() {
      let vm = this;
      vm.storesLoader = true;
      this.$store
        .dispatch(FETCH_STORES_BASIC)
        .then(data => {
          vm.stores = data.data;
          // vm.form.stores = vm.supplier.stores;
        })
        .catch(response => {
          console.log(response);
        })
        .finally(() => {
          vm.storesLoader = false;
        });
    },
    getItems() {
      let vm = this;
      this.$store
        .dispatch(FETCH_ALL_ITEMS_MULTIPLE)
        .then(data => {
          vm.items = data.data;
        })
        .catch(response => {
          console.log(response);
        })
        .finally(() => {});
    },
    getSelects() {
      let vm = this;
      let payload = {
        suppliers: {
          fields: ["id", "name"],
          search: ""
        },
        forwarders: {
          fields: ["id", "name"],
          search: ""
        },
        contractors: {
          fields: ["id", "name"],
          search: ""
        },
        clients: {
          fields: ["id", "name"],
          search: ""
        },
        stock_invoice_document_types: {
          fields: ["id", "name"],
          search: ""
        },
        stock_invoice_types: {
          fields: ["id", "name"],
          search: ""
        }
      };
      this.$store
        .dispatch(FETCH_SELECTS_BASIC, payload)
        .then(data => {
          vm.types = data.data.stock_invoice_types;
          vm.documentTypes = data.data.stock_invoice_document_types;
          vm.suppliers = data.data.suppliers;
          vm.forwarders = data.data.forwarders;
          vm.contractors = data.data.contractors;
          vm.clients = data.data.clients;
          vm.tempFirstLoader = false;
        })
        .catch(response => {
          console.log(response);
        });
    },
    onSave() {
      let vm = this;
      let message = vm.$t("PLEASE_CONFIRM");
      this.$dialog
        .confirm(message)
        .then(function() {
          let payload = vm.params;
          vm.$store
            .dispatch(CREATE_CREDIT_DEBIT_STOCK_ACTION, payload)
            .then(data => {
              vm.errors = data.data.errors;
              vm.$notify({
                group: "notify",
                type: "success",
                title: "<i class='flaticon2-checkmark'></i> Success",
                text: data.message
              });
              vm.$router.push({
                name: "stock-credit-debit-action-review",
                params: { id: data.data.id }
              });
            })
            .catch(function(response) {
              vm.errors = response.data.errors;
              vm.$notify({
                group: "notify",
                type: "error",
                title: "Error",
                text: response.data.message
              });
            });
        })
        .catch(function() {});
    },
    filterPrice() {
      let vm = this;
      vm.params.totalCurrency = this.$options.filters.formatBalance(
        vm.params.totalCurrency
      );
    },
    handleTypeIdChange() {
      let vm = this;
      // Reset counterpartyId to null
      vm.params.counterpartyId = null;

      // Adjust counterpartySlug based on typeId
      if (vm.params.typeId === 1) {
        vm.params.counterpartySlug = "client";
        vm.counterpartySlugs = [{ slug: "client", name: "Клиент" }];
      } else if (vm.params.typeId === 2) {
        // For typeId 2, include "supplier" and "forwarder" in counterpartySlugs
        vm.params.counterpartySlug = "supplier";
        vm.counterpartySlugs = [
          { slug: "supplier", name: "Доставчик" },
          { slug: "forwarder", name: "Транспортна фирма" },
          { slug: "contractor", name: "Изпълнителна фирма" }
        ];
      }
    },
    updateCounterpartySlug() {
      this.params.counterpartyId = null;
      const matchingSlugs = this.counterpartySlugs.filter(slugData =>
        slugData.typeIds.includes(this.params.typeId)
      );

      if (matchingSlugs.length > 0) {
        this.params.counterpartySlug = matchingSlugs[0].slug;
      } else {
        // Handle the case where there are no matching slugs
        this.params.counterpartySlug = null; // or some default value
      }
    },
    updateFilteredItems() {
      // Ensure that items in params.itemIds still exist in filteredItems
      const validItemIds = this.filteredItems.map(item => item.id);
      this.params.itemIds = this.params.itemIds.filter(id =>
        validItemIds.includes(id)
      );
      // alert("sad");
      // this.params.itemIds = [];
    },
    resetCounterpartyId() {
      // Reset counterpartyId to null when counterpartySlug changes
      this.params.counterpartyId = null;

      // After resetting counterpartyId, update filtered items
      this.updateFilteredItems();
    },
    updateWizardStep(step) {
      let vm = this;
      vm.actionParams.wizardStep = step;
    }
  }
};
</script>
